import { useQuery } from '@tanstack/react-query'
import { Constants } from 'constants/constants'
import { QueryKeys } from 'constants/query-keys'
import { fetchPayrollLocationMonthlyData } from 'queries/payroll/location/location'
import { PayrollFetchProps } from 'types/api'
import { IResponse } from 'utils/api'
import {
    getGreenfieldDrillValues,
    getGreenfieldLocationFilter,
} from 'utils/greenfield'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

interface PayrollLocationMonthlyFetchProps extends PayrollFetchProps {
    timeDimension?: string
}

export function usePayrollLocationMonthly({
    env,
    accessToken,
    location,
    timeDimension,
}: PayrollLocationMonthlyFetchProps): IResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const greenfieldCardNumber =
        Constants.GREENFIELD_CARDS.PAYROLL.LOCATION_MONTHLY
    const greenfieldFilters: { [key: string]: string } = {
        ...getGreenfieldDrillValues(location),
        ...getGreenfieldLocationFilter(location),
    }
    if (timeDimension) {
        greenfieldFilters.time_dimension = timeDimension
    }

    const queryOptions = {
        staleTime: tenMinutes,
        cacheTime: tenMinutes,
        retry: false,
    }

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.PAYROLL_LOCATION, location, timeDimension],
        () =>
            fetchPayrollLocationMonthlyData({
                env,
                accessToken,
                dynamicSubPath: greenfieldCardNumber,
                filters: greenfieldFilters,
                trackEvent,
            }),
        queryOptions,
    )

    return { data, isLoading, isError, refetch, remove, error }
}
